import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import HeroBanner from './components/HeroBanner';
import OurServicesSection from './components/OurServicesSection';
import WhyNeedSection from './components/WhyNeedSection';
import CTASection from './components/CTASection';
import HowWeWorkSection from './components/HowWeWorkSection';
import PricingSection from './components/PricingSection';
import ComparisonSection from './components/ComparisonSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import BenefitsSection from './components/BenefitsSection';
import IndustriesSection from './components/IndustriesSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import ContactFormDialog from './components/ContactFormDialog';
import { Toaster } from './components/ui/toaster';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import ServicePage from './pages/ServicePage';

function HomePage() {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const openForm = () => setIsContactFormOpen(true);

  return (
    <div className="bg-white">
      <Header onOpenContactForm={openForm} />
      <HeroBanner />
      <OurServicesSection />
      <WhyNeedSection onOpenContactForm={openForm} />
      <CTASection
        onOpenContactForm={openForm}
        heading="Register Your Trademark Online Today"
        paragraph="Expert trademark attorneys file, monitor, and secure your brand with the USPTO. Federal protection across all 50 states, starting at $49."
        buttonText="Start Trademark Registration"
        backgroundImage="https://images.unsplash.com/photo-1771814536262-3c1320c8e9ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxkYXJrJTIwbmF2eSUyMGJsdWUlMjBzbW9vdGglMjBncmFkaWVudCUyMGJhY2tncm91bmQlMjBtaW5pbWFsfGVufDB8fHx8MTc3NTUxMDcxM3ww&ixlib=rb-4.1.0&q=85"
      />
      <HowWeWorkSection />
      <PricingSection onOpenContactForm={openForm} />
      <ComparisonSection />
      <CTASection
        onOpenContactForm={openForm}
        heading="Amazon Brand Registry Made Simple"
        paragraph="Get your brand enrolled in Amazon Brand Registry with our combined trademark-and-enrollment service. Unlock A+ Content, Sponsored Brands, and IP protection tools."
        buttonText="Enroll in Brand Registry"
        backgroundImage="https://images.unsplash.com/photo-1614850523011-8f49ffc73908?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxkYXJrJTIwbmF2eSUyMGJsdWUlMjBzbW9vdGglMjBncmFkaWVudCUyMGJhY2tncm91bmQlMjBtaW5pbWFsfGVufDB8fHx8MTc3NTUxMDcxM3ww&ixlib=rb-4.1.0&q=85"
      />
      <WhyChooseUsSection onOpenContactForm={openForm} />
      <BenefitsSection />
      <IndustriesSection />
      <TestimonialsSection />
      <FAQSection />
      <Footer onOpenContactForm={openForm} />
      <ContactFormDialog isOpen={isContactFormOpen} onClose={() => setIsContactFormOpen(false)} />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services/:serviceSlug" element={<ServicePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
